export default {
  name: 'GraphicRiver',
  abbreviation: 'GR',
  domain: 'graphicriver.net',
  google_analytics_id: 'UA-11834194-6',
  google_remarketing_label: 'hJ8ZCL2AugMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. brochure template',
  features: {
    /**
     * @description Enables new routing strategy
     * @author Pawel Galazka / Traffic team
     * @expires
     */
    'routes:new': true,
    /**
     * @description Is true, we collapse the tags filter for all category pages unless it's a bottom level category (no children)

     * @author Geoff Evason
     * @expires Never
     */
    'collapse-tags-unless-bottom-category': true,
    /**
     * @description Enable cookiebot
     * @author Luke Robins
     * @expires
     */
    cookiebot: true
  },
  forced_features: {
    homepageNewDesign: false
  }
}
